import type { ReactNode } from "react";

import Loader from "~/components/shared/Loader.jsx";

import { useStatus } from "../../hooks/use-status";
import UserIsInValidPage from "../user-invalid-page";
import styles from "./user-validation-provider.module.css";

type UserValidationProviderProps = {
  children: ReactNode;
};

const UserValidationProvider = ({ children }: UserValidationProviderProps) => {
  const { status } = useStatus();

  if (status === "loading") {
    return (
      <div className={styles.loading}>
        <Loader />
      </div>
    );
  }

  if (status === "notVerified") {
    return (
      <div className={styles.invalid}>
        <UserIsInValidPage />
      </div>
    );
  }

  return <div className={styles.content}>{children}</div>;
};

export default UserValidationProvider;
